import { render, staticRenderFns } from "./WeltsichtenLoungeView.vue?vue&type=template&id=bb460948&scoped=true&"
import script from "./WeltsichtenLoungeView.vue?vue&type=script&lang=js&"
export * from "./WeltsichtenLoungeView.vue?vue&type=script&lang=js&"
import style0 from "./WeltsichtenLoungeView.vue?vue&type=style&index=0&id=bb460948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb460948",
  null
  
)

export default component.exports